//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import catalogsFilter from '@/components/catalogsFilter.vue';
import searchCard from '@/components/searchCard.vue';
import { searchResourceByKeyword, searchPluginByKeyword } from '@/api/search';
import { replaceToOriginStr } from '~/utils/tools';

export default {
  name: 'SearchPage',
  components: {
    catalogsFilter,
    searchCard,
  },
  data() {
    return {
      searchVal: '',
      defaultChoosed: '',
      initServerData: {
        resourceList: [],
        pluginList: [],
        total: 0,
        plugin_total: 0,
      },
    };
  },
  computed: {
    search_key() {
      return decodeURIComponent(this.$route.query.k || '');
    },
    cata_name() {
      return decodeURIComponent(this.$route.query.cata_name) || '资源';
    },
  },
  methods: {
    searchResource(searchVal) {
      if (!searchVal) return;
      this.searchVal = searchVal;
      this.$router.push({
        path: '/search',
        query: {
          searchVal,
          cata_name: this.cata_name,
        },
      });
    },
    changeCatalog(cata_name) {
      this.defaultChoosed = 0;
      const path = this.$route.path;
      const query = this.$route.query; // 这里可以用Vue的方法获取参数，也可以用正则的方法获取url中的参数
      const new_query = { ...query, cata_name };
      this.$router.push({ path, query: new_query });
      this.setSearchSensors(cata_name)
    },
    changeFilter(defaultChoosed) {
      this.defaultChoosed = defaultChoosed;
    },
    updateTotal(total, plugin_total) {
      this.initServerData = { ...this.initServerData, total, plugin_total };
    },
    setSearchSensors(cata_name) {
      const activeTab = cata_name ==='资源' ? 'resource' :'plugin'
      this.$sensors.track('event_click', {
        action_position: 'search_results',
        action_parameter1: 'category',
        action_type: activeTab
      });
    }
  },
  async asyncData({ app, query }) {
    try {
      const search_key = decodeURIComponent(query.k || '');
      app.head.title = replaceToOriginStr(`MasterGo 社区-搜索-${search_key}`);
      const [resourseRes, pluginRes] = await Promise.all([
        searchResourceByKeyword(search_key, 1, 0, app.$axios),
        searchPluginByKeyword(search_key, 1, 0, app.$axios),
      ]);
      let pluginList = [];
      let resourceList = [];
      let total = 0;
      let plugin_total = 0;
      if (resourseRes.code && resourseRes.code === 'OK') {
        resourceList = resourseRes.data || [];
        resourceList.forEach((item) => {
          item.favorite = false;
        });
        total = resourseRes.meta.page.total || 0;
      }
      if (pluginRes.code && pluginRes.code === 'OK') {
        pluginRes?.data?.forEach((element) => {
          element.loading = false;
        });
        pluginList = pluginRes.data || [];
        pluginList.forEach((item) => {
          item.favorite = false;
          item.is_install = false;
        });
        plugin_total = pluginRes.meta.page.total || 0;
      }
      const initServerData = { resourceList, pluginList, total, plugin_total };
      return {
        initServerData,
      };
    } catch (e) {
      return {};
    }
  },
};
